import { NgModule } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {KfReportingRoutingModule} from './kf-reporting-routing.module';
import {KfReportCyclesComponent} from './containers/kf-report-cycles/kf-report-cycles.component';
import {ReportCyclesTableComponent} from './components/report-cycles-table/report-cycles-table.component';
import {KfNextReportCycleComponent} from './containers/kf-next-report-cycle/kf-next-report-cycle.component';
import {KfNextReportStepBarComponent} from './components/kf-next-report-step-bar/kf-next-report-step-bar.component';
import {KfNextReportClassifiersWizardComponent} from './components/kf-nex-report-classifiers-wizard/kf-next-report-classifiers-wizard.component';
import {KfNextReportMasterTableComponent} from './components/kf-next-report-master-table/kf-next-report-master-table.component';
import {ReportCyclesFilterComponent} from './components/report-cycles-filter/report-cycles-filter.component';
import {SharedModule} from '../shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import { ClassifiersTableComponent } from './components/classifiers/classifiers-table/classifiers-table.component';
import {ClassifiersComponent} from './containers/classifiers/classifiers.component';
import { ClassifiersFiltersComponent } from './components/classifiers/classifiers-filters/classifiers-filters.component';
import { ClassifiersFormComponent } from './components/classifiers/classifiers-form/classifiers-form.component';
import { KfRegistrationAdminComponent } from './containers/kf-registration-admin/kf-registration-admin.component';
import { KfRegistrationAdminTableComponent } from './components/kf-registration/kf-registration-admin-table/kf-registration-admin-table.component';
import { KfRegistrationAdminFiltersComponent } from './components/kf-registration/kf-registration-admin-filters/kf-registration-admin-filters.component';
import { KfRegistrationValidationComponent } from './containers/kf-registration-validation/kf-registration-validation.component';
import {KfRegistrationValidationTableComponent} from './components/kf-registration/kf-registration-validation-table/kf-registration-validation-table.component';
import { KfRegistrationCostValidationTableComponent } from './components/kf-registration/kf-registration-cost-validation-table/kf-registration-cost-validation-table.component';
import { KfRegistrationRecyclingValidationTableComponent } from './components/kf-registration/kf-registration-recycling-validation-table/kf-registration-recycling-validation-table.component';
import { KfConfigurationAdminComponent } from './containers/kf-configuration-admin/kf-configuration-admin.component';
import {KfConfigurationAdminTableComponent} from './components/kf-configuration-admin/kf-configuration-admin-table/kf-configuration-admin-table.component';
import {KfConfigurationAdminFilterComponent} from './components/kf-configuration-admin/kf-configuration-admin-filter/kf-configuration-admin-filter.component';

@NgModule({
  declarations: [
    KfReportCyclesComponent,
    ReportCyclesTableComponent,
    KfNextReportCycleComponent,
    KfNextReportStepBarComponent,
    KfNextReportClassifiersWizardComponent,
    KfNextReportMasterTableComponent,
    ReportCyclesFilterComponent,
    ClassifiersComponent,
    ClassifiersTableComponent,
    ClassifiersFiltersComponent,
    ClassifiersFormComponent,
    KfRegistrationAdminComponent,
    KfRegistrationAdminTableComponent,
    KfRegistrationAdminFiltersComponent,
    KfRegistrationValidationComponent,
    KfRegistrationValidationTableComponent,
    KfRegistrationCostValidationTableComponent,
    KfRegistrationRecyclingValidationTableComponent,
    KfConfigurationAdminComponent,
    KfConfigurationAdminTableComponent,
    KfConfigurationAdminFilterComponent,
  ],
  imports: [
    CommonModule,
    KfReportingRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  providers: [
    DatePipe
  ]
})
export class KfReportingModule { }
